// Mock data for Syndicate Consultants Inc

export const companyInfo = {
  name: "Syndicate Consultants Inc",
  tagline: "International Strategic Procurement & Elite Advisory Services",
  address: "Vancouver, Canada",
  website: "www.SyndicateInc.ca"
};

export const locations = [
  "Canada",
  "Middle East",
  "North America",
  "Europe"
];

export const services = [
  {
    id: 1,
    title: "Government Procurement & Strategic Supply",
    shortDesc: "International procurement for ministries and sovereign agencies",
    description: "We secure, manage, and deliver international procurement for ministries and sovereign agencies. Our strength is speed + compliance + global access.",
    icon: "Building2",
    link: "/government-solutions",
    capabilities: [
      "Defence-compliant procurement channels (all legal & documented)",
      "Emergency medical equipment supply (Health Canada authorized)",
      "Oil & gas equipment sourcing",
      "Critical infrastructure components",
      "Government-level logistics & rapid deployment",
      "North American manufacturer relationships",
      "Tender strategy & acquisition advisory"
    ]
  },
  {
    id: 2,
    title: "Cybersecurity, AI & Digital Infrastructure",
    shortDesc: "Intelligence-grade strategy meets private-sector execution",
    description: "Modern governments face modern threats. We deliver solutions built for today's environment where intelligence-grade strategy meets private-sector execution.",
    icon: "Shield",
    link: "/government-solutions",
    capabilities: [
      "AI-driven threat detection systems",
      "Cyber-attack prevention frameworks",
      "Secure digital identity and data governance",
      "Network modernization for critical agencies",
      "National cyber-readiness programs",
      "Resilience systems for essential infrastructure"
    ]
  },
  {
    id: 3,
    title: "Luxury Fashion Procurement – Milan & Paris",
    shortDesc: "10+ years of direct luxury fashion sourcing from Europe",
    description: "Our luxury division provides high-volume and high-precision sourcing from Europe's fashion capitals, backed by 10+ years operating five luxury retail stores in Vancouver.",
    icon: "Briefcase",
    link: "/luxury-fashion",
    capabilities: [
      "Designer wholesale procurement",
      "Access to Italian & Parisian fashion houses",
      "Boutique stock acquisitions",
      "Limited-release & seasonal collection sourcing",
      "VIP wardrobe sourcing",
      "Government gifting program procurement",
      "Freight, customs, and compliant import supervision"
    ]
  },
  {
    id: 4,
    title: "Automotive Import & Export Brokerage",
    shortDesc: "Licensed, compliant, international vehicle procurement",
    description: "We source and ship exotic vehicles, limited-production cars, collector pieces, and fleet acquisitions with full title processing and customs compliance.",
    icon: "FileText",
    link: "/automotive",
    capabilities: [
      "Exotic vehicle sourcing",
      "Limited-production American & European cars",
      "Collector pieces acquisition",
      "Fleet acquisitions",
      "Government or agency-specific vehicles",
      "Title processing & export documents",
      "Customs compliance & secure transport"
    ]
  },
  {
    id: 5,
    title: "Real Estate & Urban Development Advisory",
    shortDesc: "North American development expertise for strategic projects",
    description: "Supporting housing ministries and private developers with North American-level development strategy and planning expertise.",
    icon: "Building2",
    link: "/real-estate-solutions",
    capabilities: [
      "Land acquisition advisory",
      "Multi-unit feasibility studies",
      "Commercial & residential project modeling",
      "North American planning standards applied to GCC developments",
      "Public–private partnership structuring",
      "Smart city & infrastructure alignment"
    ]
  },
  {
    id: 6,
    title: "Medical Procurement & Emergency Response Supply",
    shortDesc: "Health Canada–approved medical equipment and emergency kits",
    description: "Large-scale medical procurement for government agencies, healthcare networks, and public safety programs with full regulatory compliance.",
    icon: "Package",
    link: "/medical-procurement",
    capabilities: [
      "Emergency response kits (Naloxone, overdose kits, first-aid)",
      "Health Canada–approved Class I & II medical devices",
      "PPE and protective equipment",
      "Medical consumables and disposables",
      "Logistics, warehousing, and national distribution",
      "Quality assurance & regulatory reporting"
    ]
  },
  {
    id: 7,
    title: "Strategic International Partnerships",
    shortDesc: "Cross-border trade relationships and corporate alliances",
    description: "We connect the Middle East, Canada, the USA, and Europe through structured business alliances and procurement pipelines.",
    icon: "Shield",
    link: "/services",
    capabilities: [
      "Cross-border trade relationships",
      "Corporate–government introductions",
      "End-to-end procurement pipelines",
      "Long-term operational partnerships",
      "Market expansion strategy",
      "Bilateral trade facilitation"
    ]
  }
];

export const capabilities = [
  {
    id: 1,
    title: "Government Procurement & Strategic Supply",
    description: "North American and European supply-chain access for defence-approved equipment, medical devices, critical infrastructure components, oil & gas procurement, and high-security technologies."
  },
  {
    id: 2,
    title: "Cybersecurity, AI & Digital Infrastructure",
    description: "Advanced cyber-defense systems, AI frameworks, digital modernization programs, and secure data governance solutions for government and enterprise."
  },
  {
    id: 3,
    title: "Luxury Fashion Procurement – Milan & Paris",
    description: "10+ years of direct luxury fashion sourcing. Wholesale buying from Italy and Paris with operational experience running five luxury retail stores in Vancouver's premier shopping centres."
  },
  {
    id: 4,
    title: "Real Estate & Urban Development Advisory",
    description: "North American development expertise, feasibility planning, land acquisition strategy, and public–private partnership advisory for large-scale housing and commercial projects."
  }
];

export const industries = [
  {
    id: 1,
    name: "Government & Defence",
    description: "Strategic procurement and advisory for sovereign entities",
    image: "https://customer-assets.emergentagent.com/job_consulting-synergy/artifacts/2o8fgjrx_C9E5A8C5-DFFA-4A79-99F6-D987A5FC4926.png"
  },
  {
    id: 2,
    name: "Luxury Fashion",
    description: "European fashion house connections and wholesale procurement",
    image: "https://customer-assets.emergentagent.com/job_consulting-synergy/artifacts/2lss3g0d_8DDF2218-B0A3-4D8F-83E7-18BD6E30259C.png"
  },
  {
    id: 3,
    name: "Technology & Cybersecurity",
    description: "Advanced AI and digital infrastructure solutions",
    image: "https://customer-assets.emergentagent.com/job_consulting-synergy/artifacts/2o8fgjrx_C9E5A8C5-DFFA-4A79-99F6-D987A5FC4926.png"
  },
  {
    id: 4,
    name: "Real Estate Development",
    description: "Urban planning and large-scale project advisory",
    image: "https://customer-assets.emergentagent.com/job_consulting-synergy/artifacts/wgieivtk_3BB1B7D2-74F5-4A2A-84B0-AAFBDB3A6714.png"
  },
  {
    id: 5,
    name: "Automotive",
    description: "Exotic and collector vehicle import/export brokerage",
    image: "https://customer-assets.emergentagent.com/job_consulting-synergy/artifacts/u0l9hqq5_9D9B2815-C712-4A48-B98D-55C8653116CE.png"
  },
  {
    id: 6,
    name: "Healthcare & Medical",
    description: "Emergency medical equipment and healthcare procurement",
    image: "https://customer-assets.emergentagent.com/job_consulting-synergy/artifacts/p09mqci2_612DDF8A-844F-46FE-9213-035A440E2FB9.png"
  }
];

export const insights = [
  {
    id: 1,
    title: "Navigating International Government Procurement in 2025",
    category: "Government Relations",
    date: "January 15, 2025",
    excerpt: "Understanding the evolving landscape of international procurement and contractual commitments across borders",
    readTime: "8 min read",
    image: "https://customer-assets.emergentagent.com/job_consulting-synergy/artifacts/2o8fgjrx_C9E5A8C5-DFFA-4A79-99F6-D987A5FC4926.png"
  },
  {
    id: 2,
    title: "The Future of Cybersecurity in Government Infrastructure",
    category: "Cybersecurity",
    date: "January 10, 2025",
    excerpt: "How modern governments are adapting to AI-driven threat detection and cyber-resilience frameworks",
    readTime: "6 min read",
    image: "https://customer-assets.emergentagent.com/job_consulting-synergy/artifacts/2o8fgjrx_C9E5A8C5-DFFA-4A79-99F6-D987A5FC4926.png"
  },
  {
    id: 3,
    title: "European Luxury Fashion Procurement: A Decade of Insights",
    category: "Luxury Procurement",
    date: "January 5, 2025",
    excerpt: "Lessons from operating five luxury retail stores and sourcing directly from Milan and Paris",
    readTime: "10 min read",
    image: "https://customer-assets.emergentagent.com/job_consulting-synergy/artifacts/2lss3g0d_8DDF2218-B0A3-4D8F-83E7-18BD6E30259C.png"
  },
  {
    id: 4,
    title: "Cross-Border Trade: Connecting North America, Europe, and the Middle East",
    category: "International Trade",
    date: "December 28, 2024",
    excerpt: "Building strategic partnerships that expand influence, capability, and opportunity across continents",
    readTime: "7 min read",
    image: "https://customer-assets.emergentagent.com/job_consulting-synergy/artifacts/8d8vs3ta_396308DE-A733-4B81-9E45-26C3F8481D83.png"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Senior Government Official",
    role: "Ministry of Defense",
    content: "Syndicate Consultants delivered exceptional results on our international procurement needs. Their speed, compliance, and discretion are unmatched.",
    image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=400&h=400&fit=crop"
  },
  {
    id: 2,
    name: "Development Director",
    role: "Real Estate Corporation",
    content: "Their North American development expertise and strategic planning capabilities were instrumental in our large-scale housing project.",
    image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=400&h=400&fit=crop"
  },
  {
    id: 3,
    name: "Luxury Boutique Owner",
    role: "High-End Fashion Retail",
    content: "Ten years of direct access to European fashion houses. Their procurement expertise and supplier relationships are truly exceptional.",
    image: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=400&h=400&fit=crop"
  }
];

export const stats = [
  { label: "Years of Excellence", value: "10+" },
  { label: "Global Markets", value: "4" },
  { label: "Luxury Stores Operated", value: "5" },
  { label: "Client Satisfaction", value: "100%" }
];

export const whyChooseUs = [
  "10+ years of European luxury procurement experience",
  "Five luxury stores operated in major Canadian shopping centres",
  "Government-level procurement history in Canada",
  "North American, European & GCC supplier relationships",
  "Cybersecurity & AI integration expertise",
  "Real estate development advisory capability",
  "Total discretion, full compliance, zero compromise"
];

export const values = [
  {
    title: "Precision",
    description: "No margin for error in government-level work"
  },
  {
    title: "Discretion",
    description: "Quiet operations, confidential execution"
  },
  {
    title: "Speed",
    description: "Rapid mobilization from Canada, Italy, Paris, and the USA"
  },
  {
    title: "Global Access",
    description: "Networks built over decades"
  },
  {
    title: "Integrity",
    description: "Every offer fully compliant, above board, and transparent"
  }
];

export const careers = [
  {
    id: 1,
    title: "Procurement Specialist",
    location: "Vancouver, Canada",
    type: "Full-time",
    description: "Join our team managing international government procurement operations"
  },
  {
    id: 2,
    title: "Cybersecurity Consultant",
    location: "Remote",
    type: "Full-time",
    description: "Lead AI-driven threat detection and cyber-resilience projects"
  },
  {
    id: 3,
    title: "Luxury Fashion Buyer",
    location: "Milan / Paris",
    type: "Full-time",
    description: "Source collections from European fashion houses for international clients"
  }
];